import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Back from "~/components/Icons/arrow-prev2";
import Add from "~/components/Icons/icon-add";
import Button from "~/shared/ui/Fields/Button";
import { useSetLocationData } from "~/hooks/locationData";
import { usePermissions } from "~/shared/context/PermissionContext";
import { OpenModalActions } from "~/types/OpenModalActions";
import type { PermissionKey } from "~/types/Permissions";

const TableControl = ({
  createPermission,
}: {
  createPermission: PermissionKey;
}) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const history = useHistory();
  const { hasPermission } = usePermissions();

  const goBack = () => {
    history.replace("/editor/is/");
  };

  const openAddModal = () => setData("openModal", OpenModalActions.Add);

  return (
    <div>
      {hasPermission(createPermission) && (
        <Button
          txtBtn={t("ui.add")}
          onClick={openAddModal}
          small
          orange
          withMargin
        >
          <Add />
        </Button>
      )}
      <Button txtBtn={t("ui.back")} onClick={goBack} small>
        <Back />
      </Button>
    </div>
  );
};

export default TableControl;
